import React, { useEffect } from "react";
import Button from "../components/template/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE } from "../config";

const PaymentResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { success, email, invoiceOrderId, userDetails, program } = location.state || {};

  const handleDownloadBill = () => {
    if (!invoiceOrderId) {
      alert("Invoice not generated yet.");
      return;
    }
    const invoiceUrl = `${API_BASE}/invoices/invoice_${invoiceOrderId}.pdf`;
    window.open(invoiceUrl, "_blank");
  };

  const handleEmailBill = async () => {
    if (!invoiceOrderId) {
      alert("Invoice not generated yet.");
      return;
    }
    try {
      const response = await fetch(`${API_BASE}/email-invoice`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orderId: invoiceOrderId,
          email: userDetails?.email,
          name: userDetails?.name,
          programName: program,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        alert("Invoice emailed successfully!");
      } else {
        alert("Failed to email invoice: " + data.error);
      }
    } catch (error) {
      console.error("Error emailing invoice:", error);
      alert("Error emailing invoice. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gray-50">
      {/* Main Content */}
      <div className="flex flex-col items-center justify-center flex-grow px-6 py-12">
        <div className="bg-white border-4 border-primary rounded-lg shadow-lg w-full max-w-2xl p-8 text-center">
          <h1
            className={`text-4xl font-bold mb-4 ${
              success ? "text-green-600" : "text-red-600"
            }`}
          >
            {success ? "Thank You!" : "Payment Failed!"}
          </h1>

          {success ? (
            <>
              <p className="max-w-2xl text-gray-700 mb-2">
                Your payment was processed successfully. A receipt can be sent
                to <strong>{email}</strong>.
              </p>
              <p className="max-w-2xl text-gray-600 mb-8">
                You can download your bill or have it emailed to you.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center">
                <Button
                  onClick={handleDownloadBill}
                  text="Download Bill"
                  variant="secondary"
                  size="sm"
                />
                <Button
                  onClick={handleEmailBill}
                  text="Email Bill"
                  variant="secondary"
                  size="sm"
                />
              </div>
            </>
          ) : (
            <>
              <p className="max-w-xl text-gray-600 mb-8">
                There was an error processing your payment. Please try again.
              </p>
            </>
          )}

          <button
            onClick={() => navigate("/")}
            className="text-orange-500 font-semibold hover:text-[#5C4033] underline"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResultPage;
